var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-card',{staticClass:"box-card"},[_c('strong',{staticStyle:{"margin-top":"10px","margin-left":"10px"}},[_vm._v("包签剩余总量")]),_c('div',[_c('p',{staticClass:"label-total-count-p",attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.totalcount))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }